import * as app from './scripts/Core/App';
import Hotjar from './scripts/Modules/Hotjar';
import Analytics from './scripts/Modules/Analytics';
import ObrasFilter from './scripts/Modules/Filters/ObrasFilter';
import UltimasNotas from './scripts/Modules/UltimasNotas';
import ShowMore from './scripts/Modules/ShowMore';

app.start().then(() => {
    const hotjar = new Hotjar();
    hotjar.tagRecording('cartelera-teatro');

    // Configuracion de filtros
    const obrasFilter = new ObrasFilter({
        region: $("#filtro-region-obra"),
        zona: $("#filtro-zona-obra"),
        teatro: $("#filtro-teatro-obra"),
        dia: $("#filtro-dia-obra"),
        source: $("#lista-obras article")
    });

    // Configuracion de VER MAS (Ultimos estrenos)
    const showMore = new ShowMore($('#lista-ultimos-estrenos article'));
    $("#verMasUltimasObras").click(e => {
        showMore.showMore();
        checkShowMore();       
    });

    checkShowMore();
    filtroTeatro();


    function checkShowMore() {
        const $verMasContainer = $('#verMasUltimasObrasContainer');
        if (!showMore.needMore()) {
            $verMasContainer.hide();
        } else {
            $verMasContainer.show();
        }
    }
    function filtroTeatro() {
        obrasFilter.clear();

        obrasFilter.zona.disable();
        obrasFilter.teatro.disable();
        obrasFilter.dia.disable();

        fillSearch();

        obrasFilter.region.change(function () {
            obrasFilter.zona.clear();
            obrasFilter.teatro.clear();
            obrasFilter.dia.clear();

            obrasFilter.teatro.disable();
            obrasFilter.dia.disable();

            if (this.value) {
                $("#region-activa-obras").text(this.selectedOptions[0].text);
                obrasFilter.zona.enable();
                obrasFilter.zona.detachOptions();
                obrasFilter.zona.appendOptions(`[data-region='${this.value}']`);
            } else {
                $("#region-activa-obras").text("ARGENTINA");
                obrasFilter.zona.disable();
            }

            fillSearch();

            hotjar.tagRecording('filterTeatro');
            Analytics.trackEvent('Home cartelera', 'Uso de filtros encadenados', 'Elegí región');
        });

        obrasFilter.zona.change(function () {
            obrasFilter.teatro.clear();
            obrasFilter.dia.clear();

            obrasFilter.dia.disable();

            if (this.value) {
                obrasFilter.teatro.enable();
                obrasFilter.teatro.detachOptions();
                obrasFilter.teatro.appendOptions(`[data-zona='${this.value}']`);
            } else {
                obrasFilter.teatro.disable();
            }

            fillSearch();

            Analytics.trackEvent('Home cartelera', 'Uso de filtros encadenados', 'Elegí zona');
        });

        obrasFilter.teatro.change(function () {
            obrasFilter.dia.clear();

            if (this.value) {
                obrasFilter.dia.enable();
                obrasFilter.dia.detachOptions();
                const isAll = obrasFilter.teatro.data('all');
                if (isAll) {
                    const options = obrasFilter.teatro.items('[value!=""][data-all!=true]');
                    options.each((i, e) => {
                        obrasFilter.dia.appendOptions(`[data-teatros~='${e.value}']`);
                    });
                    obrasFilter.dia.sortOptions();
                } else {
                    obrasFilter.dia.appendOptions(`[data-teatros~='${this.value}']`);
                }
            } else {
                obrasFilter.dia.disable();
            }

            fillSearch();

            Analytics.trackEvent('Home cartelera', 'Uso de filtros encadenados', 'Elegí teatro');
        });

        obrasFilter.dia.change(e => {
            fillSearch();
            Analytics.trackEvent('Home cartelera', 'Uso de filtros encadenados', 'Elegí día');
        });

        $("#ddlTeatros").change(function () {
            hotjar.tagRecording('selectTeatro');
            Analytics.trackEvent('Home cartelera', 'Dropdown caja teatro');
            var url = $(this).find('option:selected').data('url');
            window.location.href = url;
        });

        $("#verMasObras").click(e => {
            obrasFilter.showMore();
            if (!obrasFilter.needMore()) {
                hideButton();
            }
        });


    }

    function showButton() {
        $('#verMasObrasContainer').show();
    }

    function hideButton() {
        $('#verMasObrasContainer').hide();
    }

    function fillSearch() {
        obrasFilter.fillSearch();
        if (obrasFilter.needMore()) {
            showButton();
        } else {
            hideButton();
        }
    }

    $('select[id^="filtro-region-"]').change(function () {
        let lugar = (this.value === "ciudadautonomadebuenosaires" || this.value === "1") ? "barrio" : "ciudad";
        $(this).siblings('select[id^="filtro-zona-"]').find('option:first').text("Elegí " + lugar);
    });


    // select2
    $('#ddlTeatros').select2({
        language: "es",
        placeholder: 'Todas las salas'
    });

    // Init ultimas notas de teatro
    const ultimasNotas = new UltimasNotas({ max: 3 });
    ultimasNotas.LoadUltimasDeTeatro();
});


// WEBPACK FOOTER //
// ./Statics/CarteleraTeatro.js